import { BusEvent } from '@web/common';

export class UserCreatedBusEvent extends BusEvent {}
